<template>
  <div id="radio-topics">
    <div
      :style="is_true"
      class="topic_title"
    >{{listData.order}}.( {{typeText}} ){{listData.questionTitle}}</div>
    <div class="topic_box">
      <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
        <el-radio
          :disabled="status"
          :label="item.value"
          abled
          v-if="status"
          v-model="radio"
        >{{item.lable}}</el-radio>
        <el-radio
          :label=" listData.show ?  item.value :'radio'"
          @change="getVal(item)"
          v-if="!status "
          v-model="radio"
        >{{item.lable}}</el-radio>
      </p>
    </div>
    <div class="el-Parsing" v-if="status">
      <div class="title">
        <div class="title_item">
          参考答案：
          <span class="blue">{{listData.questionAnswer}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{listData.select}}</span>
        </div>
        <div class="title_cursor">
          <el-popover
            :disabled="disabled"
            placement="bottom-start"
            trigger="click"
            v-model="visible"
            width="400"
          >
            <div class="text_box">
              <div class="header">
                <el-checkbox-group size="small" v-model="check_li">
                  <el-checkbox-button :key="item" :label="item" v-for="item in lists">{{item}}</el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div class="body">
                <el-input :rows="2" placeholder="请输入内容" type="textarea" v-model="textarea"></el-input>
              </div>
              <div class="submit">
                <div @click="submit_feed" class="btn">提交</div>
              </div>
            </div>
            <div
              :style="{'cursor': disabled? 'no-drop': 'pointer'}"
              class="warnin"
              slot="reference"
            >
              <img alt src="@/assets/img/Exam/报错.png" srcset />
              <span>试题报错</span>
            </div>
          </el-popover>
          <div class="keep" v-if="!listData.isCollect">
            <img @click="collects" alt src="@/assets/img/Exam/收藏.png" srcset />
            <span class="no_keep">试题收藏</span>
          </div>
          <div class="keep" v-else>
            <img @click="collects" alt src="@/assets/img/Exam/已收藏.png" srcset />
            <span class="is_keep">已收藏</span>
          </div>
        </div>
      </div>
      <div class="content" v-if="listData.questionDescribe">答案解析：{{listData.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
    </div>
    <div class="el-Parsing" v-if="!status">
      <div class="eye_box" v-if="!is_mode">
        <div @click="contrast" class="eye_btn">查看答案</div>
      </div>
      <div class="eye_box" v-if="is_mode">
        <div @click="upBank" class="eye_btn">收起答案</div>
      </div>
      <div class="title" v-if="is_mode">
        <div class="title_item">
          参考答案：
          <span class="blue">{{listData.questionAnswer}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red" v-if="listData.show">{{listData.select}}</span>
        </div>
      </div>
      <template v-if="is_mode">
        <div class="content" v-if="listData.questionDescribe">答案解析：{{listData.questionDescribe}}</div>
        <div class="content" v-else>答案解析：解析正在更新中...</div>
      </template>
    </div>
  </div>
</template>
<script>
import * as QUESTION_API from '@/api/ExaminationAPI'
export default {
  name: 'radioTopics',
  props: ['bankData', 'index', 'typeText', 'courseId', 'topTypeId', 'status'],
  data () {
    return {
      radio: '',
      listData: '',
      disabled: false,
      visible: false,
      lists: ['题干', '选项', '答案', '解析'],
      textarea: '',
      check_li: ['题干'],
      examinationItemData: '',
      is_mode: false,
    }
  },
  mounted () {
    let arr = this.bankData.questionSelect
    if (!(arr instanceof Array)) {
      arr = arr.split('###')
      let obj = []
      for (let i = 0; i < arr.length; i++) {
        obj[i] = {}
        obj[i].lable = arr[i]
        obj[i].value = arr[i].substring(0, 1)
      }
      this.bankData.questionSelect = obj
    }
    this.listData = this.bankData
    if (this.listData.select) {
      this.radio = this.listData.select
    }
    console.log(this.listData, ' this.listData')
  },
  computed: {
    is_true () {
      let data = ''
      if (Number(this.bankData.is_true) === 2) {
        data = {
          color: '#36ABFF'
        }
      }
      return data
    }
  },
  methods: {

    contrast () {
      this.is_mode = !this.is_mode
      if (!this.examinationItemData.answer) {
        this.isHigh = 3
      } else {
        console.log(this.examinationItemData.answer === this.examinationItemData.questionAnswer, 9999)
        if (this.examinationItemData.answer === this.examinationItemData.questionAnswer) {
          this.isHigh = 0
        } else {
          this.isHigh = 1
        }
      }
    },
    upBank () {
      this.is_mode = false
      this.isHigh = 3
    },
    //点击选项
    getVal (item) {
      this.radio = item.value
      let obj = {
        examinationItemId: this.listData.examinationItemId,
        select: item.value
      }
      console.log(obj)
      this.$emit('getChildVal', obj)

    },

    //错题反馈
    submit_feed () {
      let typeStr = "";
      if (this.check_li && this.check_li.length > 0) {
        for (let i = 0; i < this.check_li.length; i++) {
          if (i > 0) {
            typeStr += ","
          }
          const type = this.check_li[i];
          typeStr += type
        }
      }
      let data = {
        examinationItemId: this.listData.examinationItemId,
        content: typeStr + this.textarea,
        courseId: this.courseId,
        examinationId: this.listData.examinationId,
      }
      QUESTION_API.wrongFeedback(data).then(res => {
        if (res && Number(res.data.code) == 0) {
         this.$message.success(res.data.msg)
        } else {
          this.$message.warning(res.data.msg)
        }
          this.visible = false
          this.disabled = true
      }).catch(err => {
        console.log(err)
      })
    },
    //试题收藏
    editCollect (isDelete) {
      let myAnswer = this.listData.select
      let data = {
        examinationItemId: this.listData.examinationItemId,
        examinationId: this.listData.examinationId,
        questionType: this.listData.questionType,
        myAnswer: myAnswer,
        topTypeId: this.topTypeId,
        courseId: this.courseId,
        isDelete: isDelete
      }
      QUESTION_API.editExaminationItemCollect(data).then(res => {
        // if (res && Number(res.code) === 0) {

        // } else {
        //   this.$message.warning(res.msg)
        // }
        this.$message.success(res.msg)
        let isCollect = true;
        if (isDelete == 1) {
          isCollect = false;
        }
        let obj = {
          examinationItemId: this.listData.examinationItemId,
          collect: isCollect,
          push: true
        }
        this.$emit('setCollect', obj)
      }).catch(err => {
        console.log(err)
      })
    },
    //试题收藏按钮点击事件
    collects () {
      if (this.listData.isCollect) {
        this.editCollect(1)
      } else {
        this.editCollect(0)
      }
    }
  }
}
</script>
<style scoped>
.btn {
  cursor: pointer;
}
.eye_btn {
  margin: 10px;
}
.option {
  line-height: 40px;
}
.warnin img,
.warnin span {
  vertical-align: middle;
}
.warnin {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep {
  width: 78px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  border-radius: 4px 0px 0px 4px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.keep img {
  vertical-align: middle;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.title_cursor {
  display: flex;
}
.title_item {
  margin-right: 75px;
}
.headtit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.el-Parsing {
  border-top: 1px solid rgba(242, 242, 242, 1);
  border-bottom: 1px solid rgba(242, 242, 242, 1);
  margin: 35px 0;
}
.content {
  margin-bottom: 20px;
}
.topic_title {
  line-height: 60px;
}
.boxcheck {
  display: inline-block;
  text-align: center;
  width: 25px;
  height: 25px;
  background: rgba(254, 254, 254, 1);
  border: 1px solid rgba(136, 136, 136, 1);
  border-radius: 50%;
  line-height: 22px;
}
.tive {
  background: rgba(255, 39, 64, 1);
  color: white;
  border: 1px solid rgba(255, 39, 64, 1);
}
.tives {
  background: rgba(71, 162, 255, 1);
  color: #ffffffff;
  border: 1px solid rgba(71, 162, 255, 1);
}
</style>